import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Puede la depresión causar dolor físico?",
    answer:
      "Sí. La depresión puede asociarse con dolor físico y otros síntomas somáticos. Si los síntomas no mejoran con el tratamiento actual, una consulta con el equipo clínico puede ayudar a evaluar opciones.",
  },
];

export const esDepressionPhysicalPain = makeEsArticle({
  slug: "can-depression-cause-physical-pain",
  title: "¿Puede la depresión causar dolor físico?",
  description:
    "La depresión puede asociarse con dolor físico y otros síntomas somáticos. Si no mejoran con el tratamiento, una consulta puede ayudar.",
  h1: "¿Puede la depresión causar dolor físico?",
  breadcrumbLabel: "Dolor físico y depresión",
  shortAnswer:
    "Sí. La depresión puede asociarse con dolor físico, molestias y otros síntomas somáticos, además de los síntomas emocionales. Si estos síntomas no mejoran lo suficiente con el tratamiento actual, una consulta con el equipo clínico puede ayudar a evaluar opciones, incluida SAINT® para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. No hay garantías de resultados; los resultados individuales pueden variar.",
  keyTakeaways: [
    "La depresión puede asociarse con dolor físico.",
    "Puede haber otros síntomas somáticos además de los emocionales.",
    "Si no mejoran, una consulta puede ayudar.",
    "SAINT® es una opción para adultos con trastorno depresivo mayor.",
    "No hay garantías; los resultados pueden variar.",
  ],
  sections: [
    {
      heading: "Dolor físico y depresión",
      paragraphs: [
        "La depresión puede manifestarse con dolor físico, molestias, fatiga y otros síntomas somáticos, no solo con síntomas emocionales. Si estos síntomas persisten a pesar del tratamiento, conviene revisar el plan con un profesional.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
